import Vue from 'vue';


export interface AttachmentsState {
    uploadingAttachmentsInProgress: Boolean,
    attachmentsReadyToSend: Array<any>

}
export const Attachments = {
    state: Vue.observable<AttachmentsState>({
        uploadingAttachmentsInProgress: false,
        attachmentsReadyToSend: []
    }),

};